export class PageBinding {

    //for page binding 
        map = new Map([
            ["Agreements", "Agreements"],
            ["Licences", "Licences"],
            ["Contracts", "Contracts"],
            ["Permits", "Permits"],
            ["Insurance", "Insurance"],
            ["Warranty","Warranty"],
            ["Warranty Claims","Warranty Claims"],
            ["Performance Update","Performance Update"],
            ["Issue","Issue"],
            ["Asset Manager SetUp","Asset Manager SetUp"],
            ["Facility Manager SetUp","Facility Manager SetUp"]
       
        ]); 
        public getPage(subgroup: string):string {
            return this.map.get(subgroup);
        }
        submap = new Map([
            ["Compliance Manager", "Compliance Manager"],
            ["Maintenance", "Maintenance"],
            ["Performance Manager", "Performance Manager"],
            ["Warranty", "Warranty"],
            ["Assets","Assets"],
            ["Transaction SetUp","Transaction SetUp"],
            ["Schedule Update","ScheduleUpdate"],
            ["Request Material","Request Material"],
            ["Booking","Booking"]
        ]); 
    
        public getSubModulePage(subgroup: string):string {
            return this.submap.get(subgroup);
        }
    
    
    
        modulemap = new Map([
            ["Asset Manager", "Asset Manager"],
            ["Facility Manager","Facility Manager"]      
            
        ]); 
    
        public getModulePage(subgroup: string):string {
            return this.modulemap.get(subgroup);
        }
    
    }
    